import Lottie from "react-lottie";
import animationData from "../../lottie/lonely-404.json";

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

/**
 * Function to display a 404 page with an animation
 * @returns {JSX.Element}
 */
export default function NotFound() {
  window.analytics.track("Navigated to a nonexistent page");
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <div>
        {/* CSS to prevent pausing the animation */}
        <div style={{ pointerEvents: "none" }}>
          <Lottie options={lottieOptions} width={400} />
        </div>
        <h1>Unfortunately, we couldn't find that page</h1>
      </div>
    </div>
  );
}
